import { render } from "./vendor.vue?vue&type=template&id=78cd9a70"
import script from "./vendor.vue?vue&type=script&lang=js"
export * from "./vendor.vue?vue&type=script&lang=js"

import "./vendor.vue?vue&type=style&index=0&id=78cd9a70&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__